import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {ThorFSBonusFeaturePlayingController} from "../reelstoppresentation/fsbonusfeature/ThorFSBonusFeaturePlayingController";
import {ThorGameModuleConfig} from "../ThorGameModuleConfig";

/**
 * Created by Jerker Nord on 2019-06-27.
 */

export class ThorFSBonusFeatureAbortController extends WinPresentationController {

    constructor() {
        super([0, 0], {name : "ThorFSBonusFeatureAbort", skippable : false});
    }

    protected addFeatureEventHandlers():void {
        EventHandler.addEventListener(this, ThorFSBonusFeaturePlayingController.FS_FEATURE_SELECT_STARTED, ():void => this.onFSFeatureSelectStarted());
        EventHandler.addEventListener(this, ThorFSBonusFeaturePlayingController.FS_FEATURE_SELECT_ENDED, ():void => this.onFSFeatureSelectEnded());
    }

    /**
     * Not used.
     * The purpose of this class is to make the icon select animation abortable in FS mode.
     */
    protected hasWin():boolean {
        return false;
    }

    private onFSFeatureSelectStarted():void {
        this._skippable = true;
    }

    private onFSFeatureSelectEnded():void {
        this._skippable = false;
    }

    protected startWinPresentation() {
    }

    protected stopWinPresentation(isAborted:boolean):void {
        this._skippable = false;
        if(isAborted == true) {
            ThorGameModuleConfig.thorMjolnirtimeView.abort();
            EventHandler.dispatchEvent(new GameEvent(ThorFSBonusFeaturePlayingController.FS_MJOLNIR_ANIMATION_ABORTED));
            EventHandler.dispatchEvent(new GameEvent(ThorFSBonusFeaturePlayingController.FS_FEATURE_SELECT_ENDED));
            EventHandler.dispatchEvent(new GameEvent(SpinEvent.STOP));
        }
    }
}